(function () {
	class Gallery {
		constructor(params) {
			this.gallery = params.gallery;
			this.images = this.gallery.querySelectorAll('.gallery__item');
		}

		init() {
			// this.staggerThumbnails();
		}

		staggerThumbnails() {
			const thumbnails = '.gallery__item img';
			// let ease = CustomEase.create('custom', 'M0,0 C0.56,0.43 0.24,0.92 1,1 ');
			let SC = {
				trigger: '.gallery',
				// pin: true, // pin the trigger element while active
				start: 'top bottom-=150', // when the top of the trigger hits the top of the viewport
				// end: '+=1000', // end after scrolling 500px beyond the start
				toggleActions: 'play reverse play reverse',
				// markers: true,
			};

			gsap.from(thumbnails, {
				stagger: 0.3,
				autoAlpha: 0,
				yPercent: -100,
				// ease,
				scrollTrigger: SC,
			});
		}
	}

	const galleries = document.querySelectorAll('.gallery');
	if (galleries === null || galleries === undefined) return;

	galleries.forEach(gallery => {
		new Gallery({ gallery }).init();
	});
})();
